import { postData, putData } from "api/api";

export const createTool = async ({ authToken, data }) => {
  return await postData(`tool/`, data, authToken);
};

export const updateTool = async ({ authToken, id, data }) => {
  return await putData(`tool/${id}/`, data, authToken);
};
